import { createSlice } from '@reduxjs/toolkit';

export const cssVariablesSlice = createSlice({
	name: 'cssVariables',
	initialState: {
		value: null,
	},
	reducers: {
		selectCssVariables: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { selectCssVariables } = cssVariablesSlice.actions;
export const cssVariables = (state) => state.cssVariables.value;
export default cssVariablesSlice.reducer;
